<script lang="ts" setup>
</script>

<template>
  <div class="flex flex-col space-y-12">
    <DocsFeatures />
    <DocsSponsors />
  </div>
</template>
